import React from 'react';
import { Box, Typography, Button } from '@mui/joy';
import { PlayCircle as PlayCircleOutline } from '@phosphor-icons/react';

interface SetupVideoPlaceholderProps {
  videoUrl?: string;
}

export const SetupVideoPlaceholder: React.FC<SetupVideoPlaceholderProps> = ({
  videoUrl,
}) => {
  const hasVideo = !!videoUrl;

  return (
    <Box
      sx={{
        width: '100%',
        aspectRatio: '16 / 9',
        backgroundColor: 'neutral.100',
        borderRadius: 'md',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        border: '1px solid',
        borderColor: 'neutral.200',
        gap: 1.5,
        mb: 3,
      }}
    >
      <PlayCircleOutline
        size={48}
        color={hasVideo ? 'var(--joy-palette-primary-500)' : 'var(--joy-palette-neutral-400)'}
      />
      <Typography
        level="body-md"
        sx={{ color: hasVideo ? 'neutral.700' : 'neutral.500' }}
      >
        {hasVideo ? 'Watch tutorial video' : 'Tutorial video coming soon'}
      </Typography>
      {hasVideo ? (
        <Button
          variant="soft"
          color="primary"
          size="sm"
          startDecorator={<PlayCircleOutline />}
          onClick={() => window.open(videoUrl, '_blank')}
        >
          Watch Video
        </Button>
      ) : (
        <Button variant="soft" color="neutral" size="sm" disabled>
          Watch Video
        </Button>
      )}
    </Box>
  );
};

export default SetupVideoPlaceholder;
